import { useState, useEffect } from 'react';

const carouselImages = [
  '/assets/carousel/1000 CFA (1).png',
  '/assets/carousel/AnjaRubik.jpeg',
  '/assets/carousel/bleustylywoman.jpg',
  '/assets/carousel/Burokimage1.jpeg',
  '/assets/carousel/Color rules the world_ Turning a simple street….jpg',
  '/assets/carousel/Dan Bel.jpeg',
];

function ImageCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % carouselImages.length);
    }, 4000); // Change image every 4 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="overflow-hidden relative w-full h-64 min-h-[256px] rounded-2xl shadow-2xl md:h-[500px] lg:h-[550px]">
      {/* Carousel Container */}
      <div className="relative w-full h-full">
        {carouselImages.map((image, index) => {
          const position = (index - currentIndex + carouselImages.length) % carouselImages.length;
          const isActive = position === 0;

          return (
            <div
              key={index}
              className={`absolute inset-0 transition-all duration-700 ease-in-out ${
                isActive
                  ? 'opacity-100 scale-100 z-10'
                  : position === 1
                  ? 'opacity-0 scale-105 translate-x-full'
                  : 'opacity-0 scale-95'
              }`}
            >
              <img
                src={image}
                alt={`Slide ${index + 1}`}
                className="object-cover w-full h-full"
              />
            </div>
          );
        })}
      </div>

      {/* Overlay with Content */}
      <div className="absolute inset-0 z-20 bg-gradient-to-t to-transparent from-black/80 via-black/30">
        <div className="flex flex-col justify-center items-center h-full text-center">
          {/* ShopLink Logo */}
          <img
            src="/assets/images/Shoplinkpng.png"
            alt="ShopLink Logo"
            className="mb-4 h-16 md:h-20 animate-zoomIn"
          />
          
          {/* Title */}
          <h2 className="mb-2 text-3xl font-bold text-white md:text-4xl animate-slideInLeft">
            Achetez en toute simplicité
          </h2>
          
          {/* Subtitle */}
          <p className="px-4 text-lg text-white/90 md:text-xl animate-slideInRight">
            Découvrez nos produits et commandez facilement
          </p>
        </div>
      </div>

      {/* Dots Indicator */}
      <div className="flex absolute bottom-4 left-1/2 z-20 space-x-2 transform -translate-x-1/2">
        {carouselImages.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={`w-3 h-3 rounded-full transition-all duration-300 ${
              index === currentIndex
                ? 'bg-white scale-125'
                : 'bg-white/50 hover:bg-white/75'
            }`}
            aria-label={`Aller à l'image ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
}

export default ImageCarousel;

